module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('time-line', {
    attrs: {
      "showEventFilter": true,
      "target": _vm.identity,
      "fields": _vm.fields
    }
  }), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": _vm.$t('deviceInfoCardHeader'),
      "data-qa": "Content-DeviceInfo-Card-Users"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('deviceInfoLabelOwnerText')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(_vm._s(_vm.owner))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('deviceInfoLabelGuestsText')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, _vm._l((_vm.guests), function(guest, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(guest))])
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-060cb10a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeviceInfo/DeviceInfo.vue
// module id = 951
// module chunks = 3